<template>
    <div class="layout__container" v-on:drop.prevent>

        <div class="layout__padding-clear">
            <div class="layout__width-90 layout__padding-clear">
                <div class="colour__background-white">

                    <div class="text__align-center layout__margin__bottom-6px">
                        <img class="component__upload-cloud" src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/basicIcon.png"><br>
                        <h2 class="text__colour-teal layout__margin__top-10">Upload Photos</h2>
                        <p class="layout__margin__top-10">Upload your photos here ready to select fix options</p>
                    </div>

                    <div class="component__upload-portal__leading-dropzone colour__background-white" id="dropzone"
                         @dragover.prevent="ondrag" @drop="ondrop" @dragleave="onleave" v-show="showUploadBool">
                        <h3 class="text__colour-teal text__align-center text__style-bold-900">Drag and drop<br>your
                            photos here</h3>

                        <el-button class="button-red layout__margin-2-05 button__base layout__margin__top-10 layout__width-150px"
                                   v-on:click="showUpload">Or click to upload
                        </el-button>
                    </div>

                    <p v-show="showUploadBool" class="layout__padding-20-0 text__align-center">*Supported file types: jpg, jpeg, tif, tiff, png</p>

                    <div class="layout__position-center" id="progress" v-show="showProgressBool">
                        <div class="layout__width-126px layout__height-126px layout__padding-clear layout__margin__top-20px">
                            <el-progress class="layout__position__absolute" type="circle" :width="126" status="exception"
                                         :percentage="uploadPercentage" color="#00859c"></el-progress>
                            <img class="component__upload-progress__icon__leading layout__position__absolute"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/uploadProgress.png">
                        </div>
                    </div>

                    <div id="typeError" v-show="showErrorBool" class="text__align-center layout__padding-20-0">
                        <p class="text__colour-red icon-error text__size-24"></p>
                        <div class="">
                            <h4>There's a problem!</h4>
                            <p>Attempting to upload unsupported file types: </p>
                            <div v-for="(errorFile) in fileTypeErrors" v-bind:key="errorFile">
                                <p>{{errorFile}}</p>
                            </div>
                        </div>
                        <div class="layout__padding-20-0">
                        <p class="text__colour-teal">Supported file types: jpg, jpeg, tif, tiff, png</p>
                        </div>
                        <el-button class="button-red button__base layout__width-150px" v-on:click="tryAgain()">Try again</el-button>
                    </div>
                    <div id="uploadError" v-show="showUploadErrorBool" class="text__align-center">
                        <h1 class="text__colour-red icon-error layout__padding-20-0"></h1>
                        <h4>There's a problem!</h4>
                        <div class="layout__padding-20-0">
                            <p class="">We're experiencing an issue uploading the photo(s)</p>
                            <p>Please try again</p>
                        </div>
                        <el-button class="button-red layout__width-150px button__base" v-on:click="tryAgain()">
                            Try again
                        </el-button>
                    </div>
                </div>
            </div>

            <input type="file" id="leadFiles" ref="leadFiles"
                   v-on:change="buttonUpload()"
                   multiple v-show=false>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import Element from 'element-ui';
    import Axios from 'axios';
    import Router from '../../../router';
    import {axios} from '@/mixins/Axios.js';
    import {mapGetters, mapActions} from 'vuex';

    Vue.use(Element);
    export default {
        name: "FileUpload",
        props: {
            // fileTypeErrors: Array
        },
        mixins: [axios],
        data() {
            return {
                leadFiles: [],
                uploadPercentage: 0,
                // job: {},
                jobId: '',
                fixes: {},
                order: {},
                index: '',
                showUploadBool: true,
                showProgressBool: false,
                showErrorBool: false,
                showUploadErrorBool: false,
                fileUploading: '',
                fileUploadingProgress: '',
                moveToFixes: false,
                fileTypeErrors: []
            };
        },
        created() {
            console.log('fileUpload')
            console.log(this.returnHeaderUsingToken())

            if (window.sessionStorage.getItem('_jobId') != null) {
                this.jobId = JSON.parse(window.sessionStorage.getItem('_jobId'))
            } else {

                const getJobId = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/create`
                Axios.post(getJobId, {}, this.returnHeaderUsingToken())
                    .then(response => {

                        console.log(response)
                        this.jobId = response.data.id
                        window.sessionStorage.setItem('_jobId', JSON.stringify(this.jobId));
                    })

            }

            // console.log(window.sessionStorage.getItem('_fixes'))
            if (window.sessionStorage.getItem('_fixes') === null) {
                this.fixes = {
                    basicOrders: 0,
                    advanceOrders: 0,
                    orderFixes: []
                }
            } else {
                this.fixes = JSON.parse(window.sessionStorage.getItem('_fixes'))
            }


        },
        beforeUpdate() {
            // window.sessionStorage.setItem('_jobId', JSON.stringify(this.jobId));
            window.sessionStorage.setItem('_errors', JSON.stringify(this.fileTypeErrors));
        },
        methods: {
            ...mapActions([
                'incrementPhotofixrTotal',
                'decrementPhotofixrTotal'
            ]),
            tryAgain() {
                this.showUploadBool = true;
                this.showErrorBool = false;
                this.showProgressBool = false;
                this.showUploadErrorBool = false;
                this.fileTypeErrors = []
            },
            ondrag() {
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone dragover';
                // event.preventDefault(); // just opening the file
                return false;

            },

            onleave() {
                // console.log('on leave')
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone';
                // event.preventDefault(); // just opening the file
                return false;
            },

            ondrop(event) {
                // console.log('onDrop')
                event.stopPropagation();
                event.preventDefault();

                // console.log('making post to api')
                // console.log(this.job)

                this.leadFiles = event.dataTransfer.files

                this.onUpload();
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone';
            },

            showUpload() {
                document.getElementById('leadFiles').click()

            },
            buttonUpload() {
                // console.log('making post to api')
                // console.log(this.job)

                this.leadFiles = this.$refs.leadFiles.files;
                this.showUploadBool = true;

                this.onUpload();

            },
            onUpload() {
                this.fileTypeErrors = []
                this.moveToFixes = false; // done to ensure we know 1 files has been successfully update in the BATCH
                let formData = new FormData();

                for (let i = 0; i < this.leadFiles.length; i++) {

                    const file = this.leadFiles[i];
                    const fileType = file.type

                    this.uploadPercentage = 0

                    if (fileType === "image/jpeg" || fileType === "image/tiff" || fileType === "image/png") {
                        // console.log('the file IS the correct file extension')
                        // console.log(file.name)
                        this.moveToFixes = true;

                        formData.append(file.name, file, file.name);

                        this.fixes.orderFixes.push({
                            brighten_image: '',
                            add_blue_sky: '',
                            increase_vibrancy: '',
                            correct_distortion: '',
                            informationDisabled: true,
                            supportingDisabled: true,
                            add_grass: '',
                            remove_object: '',
                            information: ''
                        })

                        console.log('=+=+=+= fixes =+=+=+=')
                        console.log('=+=+=+= fixes iteration ' + i + ' =+=+=+=')
                        console.log(this.fixes.orderFixes.length)
                        console.log(this.fixes.orderFixes)

                        window.sessionStorage.setItem('_fixes', JSON.stringify(this.fixes));

                    } else {
                        // console.log('the file IS NOT the correct file extension')
                        // console.log(file.name)

                        this.fileTypeErrors.push(file.name)

                    }

                }

                if (!this.moveToFixes && this.fileTypeErrors.length !== 0) {
                    this.showErrorBool = true;
                    this.showProgressBool = false;
                    this.showUploadBool = false;
                    this.$refs.leadFiles.value = ''; // resets the upload - will resolve the bug about reloading a file x2
                } else if (this.moveToFixes) {
                    this.showErrorBool = false;
                    this.showProgressBool = true;
                    this.showUploadBool = false;
                    this.uploadFile(formData)
                }
            },
            uploadFile(formData) {

                // console.log('post to job (already created)')

                // formData.append('job', this.job)
                const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.jobId + "/orders"
                Axios.post(url, formData, {

                    headers: {
                        "content-type": "multipart/form-data",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + this.returnCookie('_token')
                    },
                    onUploadProgress: function (uploadEvent) {
                        this.uploadPercentage = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
                    }.bind(this)
                })
                    .then(response => {
                        this.job = response.data;
                        sessionStorage.setItem('_uploadedOrders', JSON.stringify(response.data.orders.length))
                        // this.leadFiles = [];

                        // this.incrementPhotofixrTotal(response.data.orders.length)


                        const basketTotals = {
                            photofixr: response.data.orders.length
                        }

                        this.$store.dispatch("incrementPhotofixrTotal", basketTotals);

                        this.$refs.leadFiles.value = ''; // resets the upload - will resolve the bug about reloading a file x2

                        this.progressToFixes(); // this has to be in the response so we don't move to quickly to the next page
                    })
                    .catch(error => {
                        // console.log(error)
                        this.$refs.leadFiles.value = ''; // resets the upload - will resolve the bug about reloading a file x2
                        this.showUploadBool = false;
                        this.showErrorBool = false;
                        this.showProgressBool = false;
                        this.showUploadErrorBool = true;
                    });

            },
            progressToFixes() {


                // if (files === index && this.moveToFixes) {
                Router.push({
                    name: '/photofixr/selections',
                    params: {
                        fileTypeErrors: this.fileTypeErrors
                    }
                });

                this.leadFiles = []
                // this.fileTypeErrors = []
                this.showUploadBool = true;
                this.showProgressBool = false;

                // console.log(window.location.pathname)
                document.getElementById('getPfJob').click()
                document.getElementById('startPhotofixrUpload').click()
                // }

            },
            sleep(time) {
                return new Promise((resolve) => setTimeout(resolve, time));
            }
        }
    }
</script>
<style scoped>
</style>
